import authOptional from '../../base/util/authOptional';
import authRequired from '../../base/util/authRequired';
import loadable from '../../shared/utils/loadable';

// Code splitting!

const CourseApplicationApp = loadable(() => import('../App'));

const Payment = loadable(() => import('../containers/Payment'));
const PaymentConfirmation = loadable(() => import('../containers/PaymentConfirmation'));
const ApplicationRequest = loadable(() => import('../containers/ApplicationRequest'));
const Review = loadable(() => import('../containers/Review'));
const EnrollmentConfirmation = loadable(() => import('../containers/EnrollmentConfirmation'));
const ReviewConfirmation = loadable(() => import('../containers/ReviewConfirmation'));
const LoginOrRegister = loadable(() => import('../containers/LoginOrRegister'));

const routes = [{
	path: '/application',
	component: CourseApplicationApp,
	routes: [{
		path: '/application/account',
		component: authOptional(LoginOrRegister)
	}, {
		path: '/application/item/:invoiceItemId/confirmation',
		component: authRequired(EnrollmentConfirmation)
	}, {
		path: '/application/item/:invoiceItemId/review',
		component: authRequired(ReviewConfirmation)
	}, {
		path: '/application/item/:invoiceItemId',
		component: authRequired(ApplicationRequest)
	}, {
		path: '/application/payment/:invoiceId/confirmation',
		component: authRequired(PaymentConfirmation)
	}, {
		path: '/application/payment/:invoiceId',
		component: authRequired(Payment)
	}, {
		// NOTE: Deprecated
		path: '/application/review',
		component: authRequired(Review)
	}, {
		path: '/application',
		exact: true,
		component: authRequired(Review)
	}]
}];

export default routes;
